import * as dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration';
import relative from 'dayjs/plugin/relativeTime';

dayjs.extend(duration);
dayjs.extend(relative);

export const dateFormat = (value) => {
    if (value) {
        let time = dayjs(value);
        return `${time.format('DD MMM YYYY HH:mm:ss').toUpperCase()}`;
    }
}

export const timeFromNow = (value) => {
    if (value) {
        return dayjs(value).fromNow();
    }
}
